<template>
  <div class="pb-15">
    <div class="card-big-title mb-8">Silo

      <span
        v-if="isWhiteGloveUser"
        class="material-icons video-tutorial-icon video-tutorial-icon-size"
        @click="$store.commit('setCurrentVideoTutorialToDisplay', {
          title: 'How to Manage silos in POP',
          videoLink: 'https://www.youtube.com/embed/bVw9DTblRg8',
          description:
            'Would you like to set up multiple report runs simultaneously? In this video, Dade, POP\'s Customer Success Manager, will guide you through the process of setting up bulk runs in POP, making project execution faster and smoother. Important: The bulk run feature is available for the team plan users only.',
          time: '0m 54s'
        })"
      >
        videocam
      </span>
    </div>
    <div v-if="isEmpty" class="silo-container-empty mb-5">
      <div class="silo-structure-empty-container">
        <img src="/static/silo-structure.svg" class="silo-structure" />
      </div>
      <div class="silo-text-empty-container">
        <div class="step-title">You haven’t created your content silo yet</div>
        <div class="title-text">
          Please add some keywords from Keyword Insight or Keyword Wizard tabs
          to create content silo for this page. You will be redirected to
          Keyword Insight tab by default.
        </div>
        <div class="gap1">
          <v-btn
            @click="gotoInsight"
            rounded
            color="profileAnchorColor"
            class="text-none whiteColor--text font16 padding8 height38"
            tag="a"
          >
            Go to Keyword Insight
          </v-btn>
          <v-btn
            rounded
            small
            outlined
            color="mainColor"
            class="mainColor--text text-none font16 padding8 height38"
            target="_blank"
            href="https://help.pageoptimizer.pro/article/how-to-use-page-optimizer-pro%E2%80%99s-new-silo-tool-to-create-custom-content-silos"
          >
            Launch tutorial
          </v-btn>
        </div>
      </div>
    </div>

    <div v-if="!isEmpty && !user.settings.hideSiloTutorialBox" class="container-launch width82 px-4 py-5 mb-10">
      <div class="flex flex-column justify-space-between width704">
        <div class="font12">GUIDE: CONTENT SILOS</div>
        <div class="font20">Explore the power of content silos</div>
        <div class="font1rem">
          Content silos help your site rank by leveraging its own authority.
          Group similar supporting <br />
          pages and point their links to your main target page using POP’s Silo
          tool.
        </div>
        <div>
          <v-btn
            rounded
            color="profileAnchorColor"
            class="text-none whiteColor--text font15 padding8 height38"
            target="_blank"
            href="https://help.pageoptimizer.pro/article/how-to-use-page-optimizer-pro%E2%80%99s-new-silo-tool-to-create-custom-content-silos"
          >
            Launch tutorial
          </v-btn>
        </div>
      </div>
      <div>
        <img src="/static/silo-structure.svg" class="silo-structure" />
      </div>
      <div class="cross-container ml-3">
        <img src="/static/cross.svg" class="cross cursor-pointer" @click="closeTutorialBox" />
      </div>
      <div></div>
    </div>

    <section v-if="!isEmpty">
      <div v-if="isWhiteGloveUser" class="sites-or-pages-container silos-container silos-container-white-glove mt-6">
        <div>
          <div class="white-glove-order-label mainColor--text mb-6">
            <i class="material-icons" style="color:#8439FF;">circle</i>
            <div class="type">New</div>
            <div class="count">{{ notOrderedSilos.length }}</div>
          </div>
          <silo-card
            v-for="(silo, idx) in notOrderedSilos"
            :key="idx"
            :silo="silo"
            :refreshData="() => fetchSilos()"
          />
        </div>
        <div>
          <div class="white-glove-order-label mainColor--text mb-6">
            <i class="material-icons" style="color:#F69C40;">circle</i>
            <div class="type">Ordered</div>
            <div class="count">{{ orderedPendingSilos.length }}</div>
          </div>
          <silo-card
            v-for="(silo, idx) in orderedPendingSilos"
            :key="idx"
            :silo="silo"
            :refreshData="() => fetchSilos()"
          />
        </div>
        <div>
          <div class="white-glove-order-label mainColor--text mb-6">
            <i class="material-icons" style="color:#EF34A4;">circle</i>
            <div class="type">In progress</div>
            <div class="count">{{ orderedInProgressSilos.length }}</div>
          </div>
          <silo-card
            v-for="(silo, idx) in orderedInProgressSilos"
            :key="idx"
            :silo="silo"
            :refreshData="() => fetchSilos()"
          />
        </div>
        <div>
          <div class="white-glove-order-label mainColor--text mb-6">
            <i class="material-icons" style="color:#1AB26A;">circle</i>
            <div class="type">Completed</div>
            <div class="count">{{ orderedCompletedSilos.length }}</div>
          </div>
          <silo-card
            v-for="(silo, idx) in orderedCompletedSilos"
            :key="idx"
            :silo="silo"
            :refreshData="() => fetchSilos()"
          />
        </div>
      </div>

      <div v-else class="sites-or-pages-container silos-container silos-container-white-glove mt-6">
        <div>
          <div class="white-glove-order-label mainColor--text mb-6">
            <i class="material-icons" style="color:#8439FF;">circle</i>
            <div class="type">New</div>
            <div class="count">{{ pendingSilos.length }}</div>
          </div>
          <silo-card
            v-for="(silo, idx) in pendingSilos"
            :key="idx"
            :silo="silo"
            :refreshData="() => fetchSilos()"
          />
        </div>
        <div>
          <div class="white-glove-order-label mainColor--text mb-6">
            <i class="material-icons" style="color:#EF34A4;">circle</i>
            <div class="type">In progress</div>
            <div class="count">{{ inProgressSilos.length }}</div>
          </div>
          <silo-card
            v-for="(silo, idx) in inProgressSilos"
            :key="idx"
            :silo="silo"
            :refreshData="() => fetchSilos()"
          />
        </div>
        <div>
          <div class="white-glove-order-label mainColor--text mb-6">
            <i class="material-icons" style="color:#1AB26A;">circle</i>
            <div class="type">Completed</div>
            <div class="count">{{ completedSilos.length }}</div>
          </div>
          <silo-card
            v-for="(silo, idx) in completedSilos"
            :key="idx"
            :silo="silo"
            :refreshData="() => fetchSilos()"
          />
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { getPureServicePkgName } from '@/utils';
import SiloCard from './SiloCard.vue';
import {
  whiteGlovePlans,
} from "@/components/plans_constants"
import rockyKeywordScreenMixin, {
  KEYWORD_SCREENS,
  MAX_LIST_ITEMS,
  summarize,
  short as rockyShort,
} from '../rockyKeywordScreen.js';

export default {
  mixins: [rockyKeywordScreenMixin],
  components: { SiloCard },
  props: ['campaignId'],
  data() {
    return {
      silos: [],
      silosLoaded: false,
    };
  },
  watch: {
    '$store.state.refreshDataAfterCartPurchase': function () {
      this.fetchSilos();
    },
    '$store.state.triggerRockyRefresh': function () {
      this.handleRockyRefresh();
    },
    silos () { this.emitRockyKeywordScreen() },
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    isWhiteGloveUser () {
      if (!this.user) return false;

      const accountType = this.$store.state.selectedSubAccountRelation
        ?this.$store.state.selectedSubAccountRelation.ownerAccountType
        :this.user.accountType

      if (whiteGlovePlans.includes(getPureServicePkgName(accountType))) {
        return true;
      }
      return false;
    },
    isEmpty() {
      return !this.silos?.length;
    },
    site () {
      return this.$store.getters.siteById(parseInt(this.$route.params.siteId)) || {};
    },
    siteId () {
      return parseInt(this.$route.params.siteId);
    },
    orderedSilos () {
      return this.silos.filter((silo) => ['paid', 'to_be_paid_by_invoice'].includes(silo?.content_report_order?.order_status));
    },
    orderedPendingSilos () {
      return this.orderedSilos.filter((silo) => silo?.content_report_order?.fulfillement_status === 'pending');
    },
    orderedInProgressSilos () {
      return this.orderedSilos.filter((silo) => silo?.content_report_order?.fulfillement_status === 'in_progress');
    },
    orderedCompletedSilos () {
      let result = this.orderedSilos.filter((silo) => silo?.content_report_order?.fulfillement_status === 'completed')
      result.sort((a, b) => {
        return new Date(b?.content_report_order?.completed_at || '2000-01-01') - new Date(a?.content_report_order?.completed_at || '2000-01-01')
      })
      return result;
    },
    notOrderedSilos () {
      return this.silos.filter((silo) => !this.orderedSilos.includes(silo));
    },
    // for non-white-glove users
    pendingSilos () {
      return this.silos.filter((silo) => silo?.fulfillement_status === 'pending');
    },
    inProgressSilos () {
      return this.silos.filter((silo) => silo?.fulfillement_status === 'in_progress');
    },
    completedSilos () {
      return this.silos.filter((silo) => silo?.fulfillement_status === 'completed');
    },
  },
  methods: {
    gotoInsight() {
      const { siteId, campaignId } = this.$route.params;
      this.$router.push(
        `/sites/${siteId}/campaign/${campaignId}/keyword-insight`,
      );
    },
    handleRockyRefresh() {
      this.fetchSilos({ silent: true });
    },
    fetchSilos(opts = {}) {
      const silent = opts.silent === true;
      if (!silent) this.$store.commit('showLoading');
      this.$store
        .dispatch('getSilos', {
          campaignId: this.$route.params.campaignId,
          paginate: 0,
          includeKeywords: 1,
          // cards read silo.page.name, so keep includePage
          includeAiAndPageRunResult: 0,
          includeGuardDiffData: 0,
        })
        .then((response) => {
          this.silos = response.data.data;
        })
        .finally(() => {
          this.silosLoaded = true;
          this.emitRockyKeywordScreen();
          if (!silent) this.$store.commit('hideLoading');
        });
    },
    // Rocky snapshot of the silo card columns exactly as they render (the
    // white-glove and standard layouts have different buckets).
    buildRockyScreenData() {
      const mapCard = (s) => {
        const activeKeywords = (s.silo_keywords || []).filter(k => !k.isDeleted);
        const topLevel = activeKeywords.find(k => k.keywordData?.isTopLevelKeyword);
        return {
          siloId: String(s.id),
          name: rockyShort(s.name),
          pageType: s.pageType != null ? s.pageType : null,
          keywordCount: activeKeywords.length,
          topLevelKeyword: topLevel ? rockyShort(topLevel.keyword) : null,
          fulfillmentStatus: s.fulfillement_status ?? s.content_report_order?.fulfillement_status ?? null,
          orderStatus: s.content_report_order?.order_status ?? null,
        };
      };
      const buckets = this.isWhiteGloveUser
        ? [
          { id: 'new', label: 'New', silos: this.notOrderedSilos },
          { id: 'ordered', label: 'Ordered', silos: this.orderedPendingSilos },
          { id: 'in_progress', label: 'In progress', silos: this.orderedInProgressSilos },
          { id: 'completed', label: 'Completed', silos: this.orderedCompletedSilos },
        ]
        : [
          { id: 'new', label: 'New', silos: this.pendingSilos },
          { id: 'in_progress', label: 'In progress', silos: this.inProgressSilos },
          { id: 'completed', label: 'Completed', silos: this.completedSilos },
        ];
      return {
        screen: KEYWORD_SCREENS.SILO_CARDS,
        status: !this.silosLoaded ? 'loading' : (this.silos.length ? 'ready' : 'empty'),
        loading: !this.silosLoaded,
        recordIds: {},
        data: {
          groups: buckets.map(b => ({
            id: b.id,
            label: b.label,
            count: b.silos.length,
            silos: summarize(b.silos, mapCard, MAX_LIST_ITEMS),
          })),
        },
      };
    },
    closeTutorialBox() {
      const updatedSettings = {
        ...this.user.settings,
        hideSiloTutorialBox: true
      }

      // eager update of settings state
      this.$store.commit('setUserSettings', updatedSettings)

      // persist in backend
      this.$store.dispatch('updateUserSettings', updatedSettings)
    }
  },
  mounted() {
    this.emitRockyKeywordScreen();
    this.fetchSilos();
  },
};

</script>

<style lang="scss" scoped>
@import './silo.scss';

.white-glove-order-label {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;

  .type {
    font-size: 16px;
    font-weight: 700;
    line-height: 13.86px;
  }

  .count {
    padding: 3px 10px;
    background: #fff;
    border: 1px solid #c7c7c7;
    border-radius: 12px;
    font-weight: 700;
  }
}
</style>
